export default __webpack_public_path__ + "static/media/unavailable_l.a0133ff5.png";